import React, { useState } from "react";
import { useCallback, useEffect } from "react";
import Chat from "../components/chat.js";
import Layout from "../components/layout.js";
import { IoClose } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import { TbChevronRight } from "react-icons/tb";
import { TbChevronLeft } from "react-icons/tb";
import { CgProfile } from "react-icons/cg";
import { useUser } from "../config/userProvider.js";
import { useNavigate } from "react-router-dom";
import { apiurl } from "../config/config.js";
import axios from "axios";


const Chats = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { userData } = useUser();
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [deleteTeamsLoading, setDeleteTeamsLoading] = useState(false);
  const [showDeleteMemberPopup, setShowDeleteMemberPopup] = useState(false);
  const [deleteTeamIds, setDeleteTeamIds] = useState([]);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({});

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${apiurl}/api/user/get?page=${currentPage}&limit=${itemsPerPage}`,
        { headers: { "Content-Type": "application/json" } }
      );
      setUsers(response?.data?.users || []);
      setPagination(response?.data?.pagination || {});
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, itemsPerPage]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);



  return (
    <Layout>
      <div
        className="layout h-full w-full overflow-hidden bg-zinc-50"
      // onClick={() => (openProfile === true ? setCloseProfile(false) : null)}
      // style={{ backgroundColor: `${theme?.sideBar["bgColour"]}20` }}c
      >



        {/* <FixallAi /> */}
        <div className="flex h-full md:p-1">
          <div
            className={` sm:relative transition-all duration-500 ease-in-out sm:translate-x-0 z-20 pb-8 overflow-hidden ${isMenuOpen
              ? "absolute flex w-[75%] md:w-[45%] lg:w-[25%] z-40 opacity-100 translate-x-0 px-3"
              : "absolute flex  w-[0%] -translate-x-full opacity-0 sm:opacity-100"
              }  md:flex flex-row md:relative gap-4 items-center h-full pt-2 shadow-sm bg-[#d8c9ae]`}
          >
            <div className="flex flex-col gap-2 items-center w-full h-full overflow-y-scroll hide-scrollbar ">
              <p className="text-xl text-white text-start w-full">Chatlist</p>

                              {
                  users.map((user) => (
                    <div key={user._id} className="px-4 flex items-center py-1 border border-white rounded-md w-full text-start">
                      <div className=" rounded-full w-6 h-6 border border-white mr-4 flex justify-center items-center flex-shrink-0"> 
                        {/* <img src={user.firstName.c || "defaultprofile.png"} alt="profile" className="w-full h-full rounded-full object-cover" /> */}
                        <p className="text-white font-bold uppercase">
                          {user.firstName?.charAt(0)}
                        </p>
                      </div>
                      <div className="w-full">
                        <p className="text-sm">{user.firstName} {user.lastName}</p>
                        <p className="text-xs text-slate-400">{user.email}</p>
                      </div>
                    </div>
                  ))
                }
            </div>
            <div className="bg-[#d8c9ae] p-2 md:hidden flex">
              {isMenuOpen ? <div
                className="text-2xl text-[#575757] cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                <TbChevronLeft className="text-xl" />
              </div> : <div className="py-2 cursor-pointer">
                <TbChevronRight onClick={() => setIsMenuOpen(true)} className="text-xl" />
              </div>}
            </div>
          </div>
          {/* <div className="bg-[#d8c9ae] p-2 h-full">
            {isMenuOpen ? <div
              className="text-2xl text-[#575757] cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              <IoClose />
            </div> : <div className="py-2 cursor-pointer">
              <RxHamburgerMenu onClick={() => setIsMenuOpen(true)} />
            </div>}
          </div> */}
          <div className="bg-[#d8c9ae] p-2 h-full flex items-center justify-center">
            {isMenuOpen ? (
              <div
                className="text-2xl text-[#575757] cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                <TbChevronLeft className="text-xl" />
              </div>
            ) : (
              <div className="cursor-pointer">
                <TbChevronRight onClick={() => setIsMenuOpen(true)} className="text-xl" />
              </div>
            )}
          </div>

          <div className="w-full flex flex-col overflow-hidden h-full border border-[#d8c9ae]">
            {isMenuOpen && (
              <div
                className=" block lg:hidden w-full h-full fixed backdrop-blur-[0.2rem] z-30"
                onClick={() => setIsMenuOpen(false)}
              ></div>
            )}
            <div
              className="h-[95vh] overflow-hidden "
            // onClick={() => setCloseProfile(false)}
            >
              {/* {children} */}
              <Chat />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Chats;